import { Typography } from '@pvh-components/typography';
import styles from './overlayWithText.module.css';

export interface OverlayWithTextProps {
  text: string;
}

const OverlayWithText = ({ text }: OverlayWithTextProps) => (
  <div className={styles.overlayWithText}>
    <Typography variant="h2" align="center">
      {text}
    </Typography>
  </div>
);

export default OverlayWithText;
